const menuItems = () => {
    return [
        {
            items: [
                {
                    icon: "pi pi-home",
                    label: "Dashboard",
                    to: "/dashboard",
                },
                {
                    icon: "pi pi-user",
                    label: "Users",
                    to: "/users",
                },
                {
                    icon: "pi pi-home",
                    label: "Services",
                    to: "/services",
                },
                {
                    icon: "pi pi-box",
                    label: "Orders",
                    to: "/orders",
                },
                {
                    icon: "pi pi-palette",
                    label: "Style Guides",
                    to: "/style-guides",
                },
                {
                    icon: "pi pi-briefcase",
                    label: "Our Work",
                    to: "/our-works",
                },

                {
                    icon: "pi pi-th-large",
                    label: "Content Management",
                    // to: "/content/terms-and-conditions",
                    items: [
                        { icon: "pi pi-briefcase", label: "Terms of service", to: "/content/terms-and-conditions" },
                        { icon: "pi pi-lock", label: "Privacy policy", to: "/content/privacy-policy" },
                        { icon: "pi pi-list", label: "FAQ", to: "/content/faq" },
                    ],
                },
                {
                    icon: "pi pi-users",
                    label: "Contacts",
                    to: "/contacts",
                },
                {
                    icon: "pi pi-comments",
                    label: "Enquiries",
                    to: "/enquiries",
                },
                {
                    icon: "pi pi-users",
                    label: "Our Clients",
                    to: "/our-clients",
                },
                {
                    icon: "pi pi-cog",
                    label: "Settings",
                    to: "/settings",
                },
            ],
        },
    ];
};

export { menuItems };
